import React, { useCallback } from 'react';
import isNil from 'lodash-es/isNil';
import { i18n_next_video } from '@yi/i18n/phrases/i18n_next_video';

import { useLocale } from '~/src/components/LocaleProvider';
import { useMediaPlayer, NextButton as NextButtonBase } from '~/src/components/MediaPlayer';

import { usePlayback } from './PlaybackProvider';

export const NextButton: React.FC = () => {
  const { player } = useMediaPlayer();
  const { locale } = useLocale();
  const { goToNextEpisode, isNextEpisodeAvailable } = usePlayback();

  const goToNextVideo = useCallback(() => {
    if (!isNil(player)) {
      goToNextEpisode();
    }
  }, [goToNextEpisode, player]);

  if (player !== null && isNextEpisodeAvailable) {
    return <NextButtonBase title={i18n_next_video(locale)} onClick={goToNextVideo} />;
  } else {
    return null;
  }
};
